import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import TaskInput from "TaskDialogCommon/TaskInput";
import RunButton from "TaskDialogCommon/RunButton";

const taskname = "archery";

export default class Dialog extends React.Component {
  constructor(props) {
    super();
    this.state = {
      taskConfig: {
        accountdetail: props.accountdetailrow,
        maxKeys: "",
        GPsToPlay: "",
        saveWheelTokens: "0",
        useWheelTokens: "200",
        stopWhenYouGetThisItems: {},
        sleepTime: "0",
      },
    };
  }

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      state: { taskConfig },
    } = this;
    return (
      <TaskDialog heading={"Archery Range"}>
        <TaskInput
          label={"Save Wheel Tokens(Optional)"}
          warning={
            "*If entered, range will save these many tokens and use the rest."
          }
          value={taskConfig.saveWheelTokens}
          onChange={(event) => setValue(event, "saveWheelTokens")}
        />
        <TaskInput
          label={"Use Tokens (Optional)"}
          warning={
            "*If entered, range will use these many tokens and save the rest."
          }
          value={taskConfig.useWheelTokens}
          onChange={(event) => setValue(event, "useWheelTokens")}
        />
        <TaskInput
          label={"Interval between spins (in seconds)"}
          warning={"*For safety purposes, the value is capped to 1 seconds."}
          value={taskConfig.sleepTime}
          onChange={(event) => setValue(event, "sleepTime")}
        />
        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Play Archery Range"}
        />
      </TaskDialog>
    );
  };
}
